import { createSelector } from 'reselect'
import { State } from 'index'

const staffSelector = (state: State) => state.staff

export const getStaffs = createSelector([staffSelector], (state) => state.staffs)
